<template>
    <div class="p-2">
        <h3 style="color: #2662bb" class="ml-1">{{ title }}</h3>
        <FormulaForm :fields="getFields()"
                     :item="item" key-name="name"
                     class="h-100 overflow-auto p-2 w-100"
                     submit-label="提交"
                     :loading="saveLoading"
                     @submit="doSave"></FormulaForm>
    </div>
</template>

<script>
import FormulaForm from "@/components/common/inputs/FormulaForm.vue";

export default {
    name: "HazardCommonEdit",
    components: {FormulaForm},
    props: {
        type: String,
        title: String,
        item: Object,
    },
    data() {
        return {
            detailFields: [
                {
                    name: 'staffType',
                    label: '人员类别',
                    type: 'select',
                    optionsFromDict: 'ehs_hazard_staff_type',
                    require: true
                },
                {
                    name: 'position',
                    label: '安全员点位',
                    type: 'select',
                    optionsFromDict: 'ehs_hazard_position',
                    help: '值班安全员请选择对应点位信息',
                    require: true
                },
                {
                    name: 'findAt',
                    label: '隐患位置',
                    type: 'select',
                    optionsFromDict: 'ehs_hazard_find_at',
                    require: true
                },
                {
                    name: 'description', label: '隐患描述', type: 'textarea', help: '请填写隐患具体工位', require: true
                },
                {
                    name: 'hazardStatus', label: '隐患处理状态', type: 'radio-select', options: [
                        {value: 1, text: '待整改'},
                        {value: 2, text: '停机'},
                        {value: 3, text: '已整改'},
                    ],
                    require: true
                },
                {
                    name: 'hazardImage', label: '隐患照片', type: 'image', multiple: true, require: true
                },
                {name: 'rectificationImage', label: '整改照片', type: 'image', multiple: true},
                {
                    name: 'rectifyDept',
                    label: '隐患整改部门',
                    type: 'select',
                    optionsFromDict: 'ehs_hazard_rectify_dept',
                    require: true
                },
            ],
            rectifyFields: [
                {
                    name: 'hazardStatus', label: '隐患处理状态', type: 'radio-select', options: [
                        {value: 1, text: '待整改'},
                        {value: 2, text: '停机'},
                        {value: 3, text: '已整改'},
                    ],
                    require: true
                },
                {name: 'rectificationDescription', label: '整改描述', type: 'textarea', require: true},
                {name: 'rectificationImage', label: '整改后照片', type: 'image', multiple: true, require: true},
            ],
            reviewFields: [
                {
                    name: 'reviewResult', label: '审核结果', type: 'select', options: [
                        {value: 1, text: '审核通过'},
                        {value: 2, text: '审核不通过'},
                    ], require: true
                },
                {
                    name: 'hazardCategory',
                    label: '隐患类型',
                    type: 'select',
                    optionsFromDict: 'ehs_hazard_category',
                    require: true
                },
            ],
            saveLoading: false,
        }
    },
    methods: {
        getFields() {
            if (this.type) {
                switch (this.type) {
                    case 'new':
                        return this.detailFields;
                    case 'rectify':
                        return this.rectifyFields;
                    case 'review':
                        return this.reviewFields;
                }
            }
            return [];
        },
        doSave(form) {
            if (this.saveLoading) {
                return;
            }
            this.saveLoading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_II_URL + "/sithMomHazardRectification/" + this.type,
                data: form
            }).then(() => {
                this.$message.success('Save Success');
                this.$emit('success', form);
            }).finally(() => this.saveLoading = false);
        },
    }
}
</script>

<style scoped>

</style>
